// Frontend/src/components/admin/forms/MinistryForm.jsx
import { useEffect, useState } from 'react';
import { STORAGE_PATHS } from '../../../constants/storagePaths';
import { uploadFile } from '../../../services/uploadFile';
import FileUpload from '../ui/FileUpload';
import Input from '../ui/Input';

const MinistryForm = ({ initialValues, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    leader: '',
    description: '',
    cover_image: '',
    logo_image: '',
    ...initialValues
  });

  const [logoPreview, setLogoPreview] = useState(initialValues?.logo_image || '');
  const [coverPreview, setCoverPreview] = useState(initialValues?.cover_image || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadErrors, setUploadErrors] = useState({});
  //const [isAuthenticated, setIsAuthenticated] = useState(false);

  /*/ Monitor auth state
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsAuthenticated(!!user);
      if (!user) {
        setUploadErrors({ auth: 'Please log in to upload files' });
      } else {
        setUploadErrors(prev => ({ ...prev, auth: null }));
      }
    });

    return unsubscribe;
  }, []);*/

  // Update form when initialValues change
  useEffect(() => {
    if (initialValues) {
      setFormData(prev => ({
        ...prev,
        ...initialValues
      }));
      setLogoPreview(initialValues.logo_image || '');
      setCoverPreview(initialValues.cover_image || '');
    }
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleLogoUpload = async (file) => {
    /*if (!isAuthenticated) {
      setUploadErrors(prev => ({ ...prev, logo: 'Please log in to upload files' }));
      return;
    }*/

    try {
      setUploadErrors(prev => ({ ...prev, logo: null }));
      console.log('Starting logo upload...');
      
      const logo_image = await uploadFile(file, STORAGE_PATHS.LOGOS);
      setFormData(prev => ({ ...prev, logo_image }));
      setLogoPreview(URL.createObjectURL(file));
      
      console.log('Logo upload successful:', logo_image);
    } catch (error) {
      console.error('Failed to upload logo:', error);
      setUploadErrors(prev => ({ ...prev, logo: error.message }));
    }
  };

  const handleCoverUpload = async (file) => {
    /*if (!isAuthenticated) {
      setUploadErrors(prev => ({ ...prev, cover: 'Please log in to upload files' }));
      return;
    }*/

    try {
      setUploadErrors(prev => ({ ...prev, cover: null }));
      console.log('Starting cover upload...');
      
      const cover_image = await uploadFile(file, STORAGE_PATHS.LOGOS);
      setFormData(prev => ({ ...prev, cover_image }));
      setCoverPreview(URL.createObjectURL(file));
      
      console.log('Cover upload successful:', cover_image);
    } catch (error) {
      console.error('Failed to upload cover:', error);
      setUploadErrors(prev => ({ ...prev, cover: error.message }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await onSubmit(formData);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Auth Status Indicator 
      {!isAuthenticated && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
          <p className="text-red-600 text-sm">
            ⚠️ You are not authenticated. Please log in to upload files.
          </p>
        </div>
      )}*/}

      <Input
        label="Ministry Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
      />
      
      <Input
        label="Leader"
        name="leader"
        value={formData.leader}
        onChange={handleChange}
        required
      />
      
      <Input
        label="Description"
        name="description"
        value={formData.description}
        onChange={handleChange}
        type="textarea"
        rows={4}
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <FileUpload
            label="Ministry Logo"
            onFileChange={handleLogoUpload}
            preview={logoPreview}
            accept="image/*"
            //disabled={!isAuthenticated}
          />
          {uploadErrors.logo && (
            <p className="text-red-500 text-sm mt-1">{uploadErrors.logo}</p>
          )}
        </div>
        
        <div>
          <FileUpload
            label="Cover Image"
            onFileChange={handleCoverUpload}
            preview={coverPreview}
            accept="image/*"
            //disabled={!isAuthenticated}
          />
          {uploadErrors.cover && (
            <p className="text-red-500 text-sm mt-1">{uploadErrors.cover}</p>
          )}
        </div>
      </div>
      
      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          className="btn btn-outline"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting }//|| !isAuthenticated}
        >
          {isSubmitting ? 'Saving...' : 'Save Ministry'}
        </button>
      </div>
    </form>
  );
};

export default MinistryForm;